import { Badge, Layout, Menu, message, Drawer } from "antd";
import React from "react";
import { connect } from "react-redux";
import {
  MdDashboard,
  MdAssignmentInd,
  MdSettingsApplications,
  MdPeople,
  MdPeopleOutline,
  MdTrendingUp,
  MdBuild,
  MdToday,
  MdStore,
  MdPlayCircleFilled,
  MdPostAdd,
  MdAutoAwesome,
  MdCampaign,
  MdFeedback,
  MdNotifications,
  MdSchedule,
  MdMedicalServices
} from "react-icons/md";
import { FaHandshake, FaRegNewspaper, FaPercent } from "react-icons/fa";
import { getAllCities } from "../../Redux/ActionCreaters/citiesRequets";
import {
  RemoveColonFromPermission,
  TopPermission,
  UserPermisstion,
} from "../../shared";
import { MAIN_BACKGROUND_COLOR, fontColor } from "../../styleConstants";
import Ads from "../Ads/Body";
import AppUser from "../AppUsers/index.js";
import CommodityRates from "../CommodityRates/CommodityRatesBody/Body";
import CrmComponent from "../Crm/CrmComponent";
import FarmersWeek from "../Farmers_of_the_Week/Body";
import FeedBack from "../FeedBack/FeedBack";

import AssignTargetUsers from "../AssignTargetCrm/assignTarget";
import FormComponent from "../Form";
import MandiGurus from "../MandiGurus/Body";
import MandiRates from "../MandiRates/Body";
import News from "../News/Body";
import NewsArticle from "../NewsAndArtical/Body";
import Franchise from "../Franchise/Body";
import PhoneDirectory from "../PhoneDirectory/Body";
import PostShower from "../Posts/PostShower";
import Medicines from "../Medicines";
import Tags from "../Tags";
import Tips from "../Tips/Body";
import Users from "../Users";
import DoctorCorner from "../Videos/Body";
import CommisionRates from "../commissionRates/Body";
import SchedulerNotification from "../scheduleNotification/Body";
import Customers from "../Customers";
import RateCorrection from "../RateCorrection";
import DailyRateBaseline from "../DailyRateBaseline";
import AIArticle from "../AIArticle";
import DraftsList from "../AIArticle/DraftsList";
import Body from "./DashboardBody/Body";
import HeaderContent from "./HeaderContent";
import { keyToPath, pathToKey } from "./routeMap";
import "./styles.css";
import "../AIArticle/styles.css";

const styles = {
  layout: {
    height: "100vh",
    overflow: "hidden",
  },
  header: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    padding: 0,
  },
  sider: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
  menu: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    color: fontColor,
    fontWeight: "bold",
  },
  content: {
    color: fontColor,
    padding: "10px",
    overflowY: "auto",
    flex: 1,
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  logo: {
    height: "200px",
    width: "190px",
    objectFit: "contain"
  },
  menuToggler: {
    color: fontColor,
    fontSize: "30px",
    marginLeft: "5px",
    marginTop: "15px",
  },
};
class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    const user = props.Auth?.user;
    let resolvedKey = "Dashboard";
    let resolvedSubkey = "";

    if (
      user?.profileDetails &&
      user.profileDetails.permissions &&
      user.profileDetails.permissions[0] !== UserPermisstion[0].value
    ) {
      let permissions = user.profileDetails.permissions;
      let firstPermission = permissions[0];
      if (
        permissions.includes(TopPermission[0].value) ||
        permissions.includes(TopPermission[1].value)
      ) {
        firstPermission = TopPermission[1].value;
      }

      resolvedKey = firstPermission.split(":")[0];
    }

    const parsedUrl = pathToKey(props.location?.pathname);
    if (parsedUrl.key) {
      resolvedKey = parsedUrl.key;
      resolvedSubkey = parsedUrl.subkey;
    }

    this.state = {
      collapsed: false,
      input: null,
      selectedKey: resolvedKey,
      slectedSubkey: resolvedSubkey,
      noficicationCount: 0,
      data: [],
    };
  }

  toggleSider = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  inputEvent = (e) => {
    this.setState({ input: e.target.value });
    console.log(e.target.value);
  };
  handleSideNavToggle = () => {
    if (window.innerWidth < 992) {
      this.setState({ collapsed: true });
    } else if (window.innerWidth > 992) {
      this.setState({ collapsed: false });
    }
  };
  // componentWillUnmount() {
  //   window?.removeEventListener("resize");
  // }
  // Authentication.user.profileDetails.permissions
  componentDidMount() {
    this.handleSideNavToggle();
    window.addEventListener("resize", this.handleSideNavToggle);
    const user = this.props.Auth?.user;
    let resolvedKey = this.state.selectedKey;
    if (
      user?.profileDetails &&
      user.profileDetails.permissions &&
      user.profileDetails.permissions[0] !== UserPermisstion[0].value
    ) {
      let permissions = user.profileDetails.permissions;
      let firstPermission = permissions[0];
      if (
        permissions.includes(TopPermission[0].value) ||
        permissions.includes(TopPermission[1].value)
      ) {
        firstPermission = TopPermission[1].value;
      }

      resolvedKey = firstPermission.split(":")[0];
      this.setState({
        allPermission: user.profileDetails.permissions,
      });
    } else if (
      user?.profileDetails &&
      user.profileDetails.permissions &&
      user.profileDetails.permissions[0] === UserPermisstion[0].value
    ) {
      this.setState({
        allPermission: user.profileDetails.permissions,
      });
    }

    // If the browser URL already points at a known page (deep link,
    // refresh, or back/forward), that takes priority over the
    // permission-derived default.
    const parsedUrl = pathToKey(this.props.location?.pathname);
    let resolvedSubkey = "";
    if (parsedUrl.key) {
      resolvedKey = parsedUrl.key;
      resolvedSubkey = parsedUrl.subkey;
    }
    this.setState({ selectedKey: resolvedKey, slectedSubkey: resolvedSubkey });
    this.props.history.replace(keyToPath(resolvedKey, resolvedSubkey));

    // Keep the sidebar/state in sync with browser back/forward navigation.
    this.unlisten = this.props.history.listen((location) => {
      if (this.isProgrammaticNav) return;
      const parsed = pathToKey(location.pathname);
      if (
        parsed.key &&
        (parsed.key !== this.state.selectedKey ||
          parsed.subkey !== this.state.slectedSubkey)
      ) {
        const nextState = { selectedKey: parsed.key, slectedSubkey: parsed.subkey };
        if (parsed.key !== "AI_Article") {
          nextState.data = undefined;
        }
        this.setState(nextState);
      }
    });

    if (!this.props.cites && user?.token) {
      this.props.getCities(user.token);
    }
    this.profRouteRenderer();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleSideNavToggle);
    if (this.unlisten) this.unlisten();
  }

  // Central navigation helper: updates local state AND pushes a real URL
  // so the address bar always reflects the active page.
  navigateTo = (selectedKey, slectedSubkey = "", data) => {
    this.isProgrammaticNav = true;
    this.setState({ selectedKey, slectedSubkey, data }, () => {
      this.isProgrammaticNav = false;
    });
    const nextPath = keyToPath(selectedKey, slectedSubkey);
    if (this.props.location?.pathname !== nextPath) {
      this.props.history.push(nextPath);
    }
  };
  profRouteRenderer = () => {
    const { app } = this.state;
    const { selectedKey, slectedSubkey } = this.state;

    if (selectedKey?.toLowerCase() === "Dashboard"?.toLowerCase())
      return (
        <Body
          setSelected={(selectedKey, slectedSubkey, data) =>
            this.navigateTo(selectedKey, slectedSubkey, data)
          }
        />
      );
    if (selectedKey?.toLowerCase() === "Dashboard/User"?.toLowerCase())
      return (
        <AppUser
          setSelected={(selectedKey) => this.navigateTo(selectedKey)}
          slectedSubkey={slectedSubkey}
          selectedKey={selectedKey}
          data={this.state.data}
        />
      );

    if (selectedKey === "Users") return <Users />;
    if (selectedKey === "Customers") return <Customers />;
    if (selectedKey === "CommodityRates") return <CommodityRates />;
    if (selectedKey === "RateCorrection") return <RateCorrection />;
    if (selectedKey === "DailyRateBaseline") return <DailyRateBaseline />;
    if (selectedKey === "MandiRates") return <MandiRates />;
    if (selectedKey === "MandiGurus") return <MandiGurus />;
    if (selectedKey === "Videos") return <DoctorCorner />;
    if (selectedKey === "News_Articles")
      return (
        <NewsArticle
          editArticle={this.state.data}
          clearEditArticle={() => this.setState({ data: null })}
          setSelected={(selectedKey, slectedSubkey, data) =>
            this.navigateTo(selectedKey, slectedSubkey, data)
          }
        />
      );
    if (selectedKey === "AI_Article")
      return (
        <AIArticle
          editArticle={this.state.data}
          clearEditArticle={() => this.setState({ data: null })}
          setSelected={(selectedKey, slectedSubkey, data) =>
            this.navigateTo(selectedKey, slectedSubkey, data)
          }
        />
      );
    if (selectedKey === "Drafts")
      return (
        <DraftsList
          Auth={this.props.Auth}
          setSelected={(selectedKey, slectedSubkey, data) =>
            this.navigateTo(selectedKey, slectedSubkey, data)
          }
        />
      );
    if (selectedKey === "Franchase") return <Franchise />;
    if (selectedKey === "Crm_System")
      return (
        <CrmComponent
          setSelected={(selectedKey, slectedSubkey, data) =>
            this.navigateTo(selectedKey, slectedSubkey, data)
          }
        />
      );
    if (selectedKey === "AssignTarget") return <AssignTargetUsers />;
    if (selectedKey === "Posts") return <PostShower />;
    if (selectedKey === "Medicines") return <Medicines />;
    if (selectedKey === "Schedule-Notification")
      return (
        <SchedulerNotification
          slectedSubkey={slectedSubkey}
          setSelected={(selectedKey, slectedSubkey) =>
            this.navigateTo(selectedKey, slectedSubkey)
          }
        />
      );

    if (selectedKey === "Tips") return <Tips />;
    if (selectedKey === "News") return <News />;
    if (selectedKey === "FarmersWeek") return <FarmersWeek />;
    if (selectedKey === "Ads") return <Ads />;
    if (selectedKey === "CommissionRates") return <CommisionRates />;

    if (selectedKey === "PhoneDirectory") return <PhoneDirectory />;
    // if (selectedKey === "Reports") return <Reports />;
    if (selectedKey === "FeedBack") return <FeedBack />;
    if (selectedKey === "Notification") return <FormComponent />;
    if (selectedKey === "Tags") return <Tags />;
  };
  changeProfRoute = (key) => {
    this.navigateTo(key);
  };

  render() {
    const { Sider, Header, Content } = Layout;
    const user = this.props.Auth?.user;
    const permissions = user?.profileDetails?.permissions;
    if (!user || !permissions) {
      localStorage.clear();
      window.location.href = "/signin";
      // message.error("You have not any permission");
      return null;
    }
    const PermissionsRomovingColor = RemoveColonFromPermission(permissions || []);

    return (
      <Layout style={styles.layout}>
        {window.innerWidth > 992 && (
          <Sider
            trigger={null}
            width={250}
            className="custom-sider-scroll"
            style={{
              ...styles.sider,
              display: this.state.collapsed ? "none" : "block",
            }}
          >
            <div style={styles.logoContainer}>
              <img
                src="/image/logo.png"
                style={styles.logo}
                alt="Poultry Baba"
              />
            </div>
            <Menu
              style={styles.menu}
              mode="inline"
              onSelect={({ key }) => this.changeProfRoute(key)}
              selectedKeys={[this.state.selectedKey === "Drafts" ? "News_Articles" : this.state.selectedKey.split("/")[0]]}
            >
              {this.renderMenuItems(PermissionsRomovingColor)}
            </Menu>
          </Sider>
        )}
        <Layout className="site-layout" style={{ height: "100vh", overflow: "hidden" }}>
          <Header className="site-layout-background" style={styles.header}>
            <HeaderContent
              toggleSider={this.toggleSider}
              collapsed={this.state.collapsed}
              name={this.state.input}
              onChange={this.inputEvent}
              onNotification={(noficicationCount) =>
                this.setState({ noficicationCount })
              }
            />
          </Header>
          <Content style={styles.content}>{this.profRouteRenderer()}</Content>
          {window.innerWidth <= 992 && (
            <Drawer
              placement="left"
              closable={true}
              onClose={this.toggleSider}
              visible={!this.state.collapsed}
              key="left"
              bodyStyle={{
                padding: 0,
                backgroundColor: MAIN_BACKGROUND_COLOR,
              }}
              headerStyle={{
                backgroundColor: MAIN_BACKGROUND_COLOR,
                borderBottom: "none",
              }}
              width={250}
            >
              <div style={styles.logoContainer}>
                <img
                  src="/image/logo.png"
                  style={styles.logo}
                  alt="Poultry Baba"
                />
              </div>
              <Menu
                style={styles.menu}
                mode="inline"
                onSelect={({ key }) => {
                  this.toggleSider();
                  this.changeProfRoute(key);
                }}
                selectedKeys={[this.state.selectedKey === "Drafts" ? "News_Articles" : this.state.selectedKey.split("/")[0]]}
              >
                {this.renderMenuItems(PermissionsRomovingColor)}
              </Menu>
            </Drawer>
          )}
        </Layout>
      </Layout>
    );
  }

  renderMenuItems = (PermissionsRomovingColor) => {
    return (
      <>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Dashboard")
              ? false
              : true
          }
          key="Dashboard"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdDashboard style={{ fontSize: "17px" }} />
            <span>Dashboard</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("AssignTarget")
              ? false
              : true
          }
          key="AssignTarget"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdAssignmentInd style={{ fontSize: "17px" }} />
            <span>Assign Target CRM</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("CommissionRates")
              ? false
              : true
          }
          key="CommissionRates"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <FaPercent style={{ fontSize: "17px" }} />
            <span>Commission Rates</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes("Crm_System") ? false : true
          }
          key="Crm_System"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdSettingsApplications style={{ fontSize: "17px" }} />
            <span>CRM System</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Users")
              ? false
              : true
          }
          key="Users"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdPeople style={{ fontSize: "17px" }} />
            <span>Users</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Users")
              ? false
              : true
          }
          key="Customers"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdPeopleOutline style={{ fontSize: "17px" }} />
            <span>Customers</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("CommodityRates")
              ? false
              : true
          }
          key="CommodityRates"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdTrendingUp style={{ fontSize: "17px" }} />
            <span>Commodity Rates</span>
          </span>
        </Menu.Item>
        {/* MoM 16 Apr 2025, item 13 — Admin rate correction page.
            Dedicated RateCorrection permission; CommodityRates kept as
            fallback so existing sub-admins don't lose access. */}
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) ||
            PermissionsRomovingColor.includes("RateCorrection") ||
            PermissionsRomovingColor.includes("CommodityRates")
              ? false
              : true
          }
          key="RateCorrection"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdBuild style={{ fontSize: "17px" }} />
            <span>Rate Correction</span>
          </span>
        </Menu.Item>
        {/* Daily admin baseline — Punjab × 6 commodities (Apr 2026 product). */}
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) ||
            PermissionsRomovingColor.includes("RateCorrection") ||
            PermissionsRomovingColor.includes("CommodityRates")
              ? false
              : true
          }
          key="DailyRateBaseline"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdToday style={{ fontSize: "17px" }} />
            <span>Daily Rate Baseline</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("MandiRates")
              ? false
              : true
          }
          key="MandiRates"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdStore style={{ fontSize: "17px" }} />
            <span>Mandi Rates</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Videos")
              ? false
              : true
          }
          key="Videos"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdPlayCircleFilled style={{ fontSize: "17px" }} />
            <span>Videos</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Posts")
              ? false
              : true
          }
          key="Posts"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdPostAdd style={{ fontSize: "17px" }} />
            <span>Posts</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Posts")
              ? false
              : true
          }
          key="Medicines"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdMedicalServices style={{ fontSize: "17px" }} />
            <span>Medicines</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("News_Articles")
              ? false
              : true
          }
          key="News_Articles"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <FaRegNewspaper style={{ fontSize: "17px" }} />
            <span>News & Articles</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={false}
          key="AI_Article"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdAutoAwesome style={{ fontSize: "17px" }} />
            <span>AI Article (CMS)</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Ads")
              ? false
              : true
          }
          key="Ads"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdCampaign style={{ fontSize: "17px" }} />
            <span>Ads</span>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("FeedBack")
              ? false
              : true
          }
          key="FeedBack"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdFeedback style={{ fontSize: "17px" }} />
            <span>Feedback & suggestion</span>
            <Badge count={this.state.noficicationCount}> </Badge>
          </span>
        </Menu.Item>
        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Notification")
              ? false
              : true
          }
          key="Notification"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdNotifications style={{ fontSize: "17px" }} />
            <span>Notification</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Notification")
              ? false
              : true
          }
          key="Schedule-Notification"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <MdSchedule style={{ fontSize: "17px" }} />
            <span>Schedule Notification</span>
          </span>
        </Menu.Item>

        <Menu.Item
          disabled={
            PermissionsRomovingColor.includes(
              UserPermisstion[0].value.split(":")[0]
            ) || PermissionsRomovingColor.includes("Franchase")
              ? false
              : true
          }
          key="Franchase"
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <FaHandshake style={{ fontSize: "17px" }} />
            <span>Franchise Request</span>
          </span>
        </Menu.Item>
      </>
    );
  };
}

const mapStateToProps = (store) => ({
  Auth: store.Authentication,
  cities: store.Cities.cities,
  isMobileView: store.Setting.isMobileView,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getCities: (token) => {
      dispatch(getAllCities(token));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
